import { Marker, Popup, useMap } from 'react-leaflet';
import { littleDot } from './CustomIcons';
import { getAllPoints } from '../api/base';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';

const getRandomColor = () => {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

const Points = (props) => {
    const { isAllUrlParamsDontExist } = props;

    const [positions, setPositions] = useState([]);

    const map = useMap();

    useEffect(() => {
        const asyncUseEffect = async () => {
            toast.info('Загрузка точек...', { toastId: 'dots_loading', isLoading: true, autoClose: false });

            try {
                const response = await getAllPoints();
                setPositions(
                    response.data.map((pos) => ({
                        lat: pos.latitude,
                        lng: pos.longitude,
                        id: pos.local_id,
                        time: pos.time,
                        bearing: pos.bearing,
                        speed: pos.speed,
                    }))
                );
                if (isAllUrlParamsDontExist) {
                    let maxLat = 0;
                    let minLat = 0;
                    let maxLng = 0;
                    let minLng = 0;
                    for (let i = 0; i < response.data.length; ++i) {
                        if (response.data[i].latitude > maxLat) {
                            maxLat = response.data[i].latitude;
                        }
                        if (response.data[i].longitude > maxLng) {
                            maxLng = response.data[i].longitude;
                        }
                        if (response.data[i].latitude < minLat) {
                            minLat = response.data[i].latitude;
                        }
                        if (response.data[i].longitude < minLng) {
                            minLng = response.data[i].longitude;
                        }
                    }
                    const centerLat = (minLat + maxLat) / 2;
                    const centerLng = (minLng + maxLng) / 2;
                    const zoom = Math.round(Math.max(maxLat - minLat, maxLng - minLng) / 20);
                    // console.log(zoom); // надо потестить, но вроде норм, если делить на 20
                    map.setView([centerLat, centerLng], zoom || 2);
                }
                toast.update('dots_loading', {
                    isLoading: false,
                    autoClose: 2000,
                    render: 'Точки загружены!',
                    type: 'success',
                });
            } catch (error) {
                toast.update('dots_loading', {
                    isLoading: false,
                    autoClose: 2000,
                    render: error.message,
                    type: 'error',
                });
            }
        };
        asyncUseEffect();
    }, [map, isAllUrlParamsDontExist]);

    return (
        <>
            {positions.map((position) => {
                return (
                    <Marker
                        position={position}
                        opacity={0.8}
                        key={uuid()}
                        icon={littleDot(getRandomColor(), getRandomColor())}
                    >
                        <Popup>
                            {`(${position.lat}, ${position.lng})`}
                            <br />
                            {`Speed: ${position.speed}.`}
                            <br />
                            {`Bearing: ${position.bearing}.`}
                        </Popup>
                    </Marker>
                );
            })}
        </>
    );
};

export default Points;
